/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import "antd/dist/antd.less";
import "antd/dist/antd.css";
import './app.css';
import './font-icon.css';
import {
	BrowserRouter as Router,
	Switch,
	Route,
} from 'react-router-dom';
import { flatRoutes } from './routes';
import { AppRouteType } from '__utils/type';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCartDetails } from 'views/cart/cart.actions';
import Flash from 'components/flash';
import { getRandomCookie, setRandomCookie, getUserDetails, setUserDetails, setAgentCode, getAgentCode, delete_cookie, setOrgCartInfoFromSession, delete_cookie_byDomain, setCookieId, set_cookie_byDomain, removeUserDetails, removeCartDetails } from '__utils/storage';
import { fetchGetPartnerStatus, fetchGetCurrentUser, fetchgetPortfolioDetails, setSigninStep } from 'views/login/login.actions';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import { useDeepCompare } from "hooks/use-deep-memo";
import Loader from 'components/loader';
import { getQueryParamsFromString, logOutUser, isProUser, getCartId, isRedirectFromMintpro, clearAllCookies, redirectBasedOnBSE, isBtoCFlow, returnTaxCode, getEncryptedUserId } from '__utils/common-utils';
import { useHistory } from "react-router-dom";
import Login from 'views/login';
import elementVisibilty from '__utils/toggleVisibilty-util';
import { fetchAgentCertificates, fetchCustomerCount, fetchCustomerOrderDetails, fetchGetCalculatorLeadsCount, fetchPostMergeCarts,fetchAgentVerification } from 'views/user/user.actions';
import { SET_NAME_IN_HEADER } from 'constants/actions';
import { fetchRiskProfileResult } from 'views/investor-profile/risk-profile/risk-profile.actions';
import AppRoute from 'components/app-routes';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import Share from 'components/share';
import { fetchAllMintpacks } from 'views/render-view/renderView.actions';
import { getEventName, identify, Mixpanel } from '__utils/mixpanel';
import PendingOrderPopup from 'components/pending-order-popup';
import useFlashToggler from 'hooks/use-flash-toggler';


const App: React.FC = () => {

	const { history } = useHistory();

	const dispatch = useDispatch();
	const flash = useFlashToggler();


	const handleTabChange = () => {
		const USER_CART_COOKIE: any = process.env.REACT_APP_CART_COOKIE_NAME;
		const PRO_COOKIE_URL: any = process.env.REACT_APP_PRO_COOKIE_URL;
		if (document.visibilityState === "visible") {
			let currentTabUser = sessionStorage.getItem('userInfo');
			let currentTabUserAgent = sessionStorage.getItem('agentCodeCookie');
			let currentTabMintproAgent = sessionStorage.getItem('agentCodeMintpro');
			let currentTabcookieId = sessionStorage.getItem('cookieId');
			if (currentTabcookieId) {
				setCookieId(currentTabcookieId);
			}
			if (currentTabMintproAgent) {
				setAgentCode(currentTabMintproAgent);
				set_cookie_byDomain('agentCode', currentTabMintproAgent, PRO_COOKIE_URL);
			} else {
				delete_cookie_byDomain('agentCode', PRO_COOKIE_URL);
			}
			if (currentTabUser) {
				setUserDetails(JSON.parse(currentTabUser));
				let currentTabUserCart = sessionStorage.getItem(USER_CART_COOKIE);
				setOrgCartInfoFromSession(currentTabUserCart);

				if (currentTabUserAgent) {
					setAgentCode(currentTabUserAgent);
				} else {
					delete_cookie('agentCode', true);
					delete_cookie_byDomain('agentCode', PRO_COOKIE_URL);

				}
			} else {
				removeUserDetails();
			}

		}

	}
	useEffect(() => {
		document.addEventListener("visibilitychange", handleTabChange);
		return () => {
			document.removeEventListener('visibilitychange', handleTabChange);
		};
	});

	useEffect(() => {
		identify(getAgentCode() || '');
		const { agentCode } = getQueryParamsFromString(window.location.search);
		if (agentCode) {
			setAgentCode(agentCode);
		}

	})

	useEffect(() => {
		var urlParams = new URLSearchParams(window.location.search);
		if (isRedirectFromMintpro(urlParams)) {
			clearAllCookies();
			const partnerId = urlParams.get("agentCode")!;
			sessionStorage.setItem('agentCodeMintpro', partnerId);
			const sachetProduct = {
				partnerId: partnerId
			};
			const sachetProductString = JSON.stringify(sachetProduct);
			sessionStorage.setItem('sachet-product', sachetProductString);
			document.cookie = `dealerUserName=${partnerId}; domain=.turtlefin.com; path=/`;
		}
		const { agentCode } = getQueryParamsFromString(window.location.search);
		dispatch(fetchAllMintpacks());
		if (agentCode) {
			setAgentCode(agentCode);
		}

		if (getAgentCode()) {
			getAgentVerification();
			//fetches agent details(name,number,arnholder)
			if (isProUser()) {
				dispatch(fetchAgentVerification(getAgentCode() || ''));
				dispatch(fetchCustomerCount(getAgentCode() || ''));
				dispatch(fetchAgentCertificates(getAgentCode() || ''));
				dispatch(fetchCustomerCount(getAgentCode() || ''));
				dispatch(fetchGetCalculatorLeadsCount());
			}
		}
		if (!getRandomCookie()) {
			setRandomCookie();
		}
		if (getUserDetails()) {
			dispatch(fetchGetCurrentUser());
			dispatch(fetchgetPortfolioDetails(false,getEncryptedUserId()));
			dispatch({
				type: SET_NAME_IN_HEADER,
				payload: getUserDetails().name
			});
			dispatch(fetchRiskProfileResult());
			dispatch(fetchCustomerOrderDetails());
		}
		if (getCartId() || getUserDetails()) {
			dispatch(fetchCartDetails());
		}
		//track PWA installation event
		window.addEventListener('appinstalled', () => {
			Mixpanel.track(getEventName("pwainstallation", "clicked", "home"));
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	// function for idle user on MF
	let elapsedTime = 0
	const onfocus = () => { elapsedTime = 0 }
	const onclick = () => { elapsedTime = 0 }
	const onkeyup = () => { elapsedTime = 0 }
	const onmouseover = () => { elapsedTime = 0 }
	onfocus(); onclick(); onkeyup(); onmouseover();
	if (window.Touch) { elapsedTime = 0 }
	let frequency = setInterval(function () {
		elapsedTime++
		if (!getUserDetails()) {
			elapsedTime = 0
		}
		if (elapsedTime > 1800 && getUserDetails()) { // half an hour timeout
			clearInterval(frequency)
			logOutUser();
		}
	}, 1000)

	const { currentUserDetails } = propsToJS(useSelector(LoginSelector));
	useEffect(() => {
		if (currentUserDetails) {
			if (Array.isArray(currentUserDetails) && currentUserDetails?.length > 1) {
				dispatch(setSigninStep('multipleUsers'))
			}
			else {
				const userInfo = Array.isArray(currentUserDetails) ? currentUserDetails[0].tokenInfo : currentUserDetails ;
				if(userInfo?.user?.taxStatus == "02" && userInfo?.user?.majorStatus) {
					sessionStorage.setItem("minorToken", userInfo?.token);
					sessionStorage.setItem("majorStatus", userInfo?.user?.majorStatus);
					removeCartDetails();
					window.location.pathname = "/v1/profile/portfolio";
				} else {
					if(sessionStorage.getItem('minorToken') || sessionStorage.getItem('majorStatus')){
						sessionStorage.removeItem('minorToken');
						sessionStorage.removeItem('majorStatus');
					}
					dispatch({
						type: SET_NAME_IN_HEADER,
						payload: userInfo?.user.name
					});
					setUserDetails(userInfo);
					if (userInfo.user && userInfo.user.mintAgentCode) setAgentCode(userInfo.user.mintAgentCode);
					const element: HTMLElement | null = document.getElementById('loginDiv');
					if (element && element?.style.display === 'block') {
						flash.success(`You have successfully logged in to ${userInfo?.user?.name}'s account.`);
						dispatch(fetchPostMergeCarts(isBtoCFlow()))
						elementVisibilty.hide('loginDiv');
						redirectBasedOnBSE(userInfo);
					}
				}
			}

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [useDeepCompare(currentUserDetails)]);

	const getAgentVerification = () => {
		get(ENDPOINTS.GET_PARTNER_DETAILS + `?agentCode=${getAgentCode()}`, getDefaultHeaders(), true)
			.subscribe((response: AjaxResponse | AjaxError) => {
				dispatch(fetchGetPartnerStatus(response?.response?.data?.data?.partnerStatus));
			}, (error: AjaxError) => {
				console.error(error);
			});
	}

	return (
		<Router basename="/v1">
			<div>
				<Switch>
					{flatRoutes.map((item: AppRouteType) => {
						return item.layout ? (
							<AppRoute
								key={item.key}
								path={item.path}
								component={item.component}
								exact={item.exact ? item.exact : false}
								layout={item?.layout}
								headerIconSet={item?.headerIconSet}
							/>
						) : (<Route
							key={item.key}
							path={item.path}
							component={item.component}
							exact={item.exact ? item.exact : false}
						/>

						);
					})}
				</Switch>
				<Flash />
				<Loader />
				<Share />
				<Login />
				<PendingOrderPopup />
			</div>
		</Router>
	);
};

export default App;
